'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBodyClassname = require('react-body-classname');

var _reactBodyClassname2 = _interopRequireDefault(_reactBodyClassname);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _translate = require('../../redux/i18n/translate');

var _translate2 = _interopRequireDefault(_translate);

var _About = require('components/About');

var _Util = require('components/Util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var About = (_dec = (0, _reactRedux.connect)(function (state, props) {
  return { currentLanguage: state.language.lang };
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(About, _Component);

  function About(props) {
    (0, _classCallCheck3.default)(this, About);

    var _this = (0, _possibleConstructorReturn3.default)(this, (About.__proto__ || (0, _getPrototypeOf2.default)(About)).call(this, props));

    _this.handleScroll = _this.handleScroll.bind(_this);

    /* currentView:
        1 -> Investigaciones 
        2 -> Diccionario
        3 -> Tutoriales
        4 -> Créditos
    */
    _this.state = {
      currentView: 1,
      lastScrollPosition: 0,
      headerStyle: 'show'
    };
    return _this;
  }

  (0, _createClass3.default)(About, [{
    key: 'componentDidMount',
    value: function componentDidMount() {

      if (this.context.router.goTo) {
        this.gotToPart(this.context.router.goTo);
      } else {

        setTimeout(function () {
          this.manageElements('down');
          //console.log('----------')
        }.bind(this), 1000);
      }
    }
  }, {
    key: 'gotToPart',
    value: function gotToPart(goTo) {
      var _this2 = this;

      var elem = parseInt(goTo - 1);
      document.getElementsByClassName('linkToPart')[elem].click();

      this.setState({
        currentView: goTo
      }, function () {
        delete _this2.context.router.goTo;
      });
    }
  }, {
    key: 'changeView',
    value: function changeView(ev) {
      var _this3 = this;

      ev.preventDefault ? ev.preventDefault() : ev.returnValue = false;

      var elem = void 0,
          newCurrentView = void 0;
      ev.target.tagName == 'SPAN' ? elem = ev.target.parentElement : elem = ev.target;

      newCurrentView = parseInt(elem.getAttribute('data-position'));

      document.getElementsByClassName('bottomLine active')[0].classList.remove('active');
      this.setState({
        currentView: newCurrentView
      }, function () {
        elem.getElementsByClassName('bottomLine')[0].classList.add('active');

        if (elem.getAttribute('data-position') < 4) {
          _this3.manageElements('down');
        }
      });

      this.goTop();
    }
  }, {
    key: 'showElement',
    value: function showElement(elem, direction) {
      if (direction == 'down') {
        elem.classList.add('fadeInUp');
      }
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll(ev) {
      var newScrollPosition = window.scrollY;
      var finalDirection = '';

      if (newScrollPosition < this.state.lastScrollPosition) {
        finalDirection = 'up';
      } else {
        finalDirection = 'down';
      }

      if ($('.aboutElement').scrollTop() == 0) {
        this.setState({
          headerStyle: 'show'
        });
      } else if ($('.aboutElement').scrollTop() > 0) {
        this.setState({
          headerStyle: 'hide'
        });
      }

      this.setState({
        lastScrollPosition: newScrollPosition
      });

      this.manageElements(finalDirection);
    }
  }, {
    key: 'manageElements',
    value: function manageElements(direction) {
      // hiddenTxt animated --> clases q añadir a los elementos q se ocultan y muestran
      //console.log(direction);
      var elements = document.getElementsByClassName('hiddenTxt');
      var bottomLimit = document.documentElement.clientHeight;
      var topLimit = document.documentElement.clientHeight - document.getElementsByClassName('aboutElement')[0].clientHeight;

      if (direction == 'down') {
        for (var i = 0; i <= elements.length - 1; i++) {
          var topElem = elements[i].getBoundingClientRect().top;
          var bottomElem = elements[i].getBoundingClientRect().bottom;

          if (topElem < bottomLimit && topElem > topLimit) {
            this.showElement(elements[i], direction); //OKS
          }
        }
      }
    }
  }, {
    key: 'goTop',
    value: function goTop() {
      var _this4 = this;

      this.setState({
        headerStyle: 'show'
      }, function () {
        //fadeInUp
        var elements = document.getElementsByClassName('hiddenTxt');

        for (var i = 0; i <= elements.length - 1; i++) {
          _this4.showElement(elements[i], 'down'); //OKS
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$strings = this.props.strings,
          title = _props$strings.title,
          menu = _props$strings.menu,
          dictionary = _props$strings.dictionary,
          investigations = _props$strings.investigations,
          tutorials = _props$strings.tutorials;
      var elem1 = menu.elem1,
          elem2 = menu.elem2,
          elem3 = menu.elem3;

      var currentView = this.state.currentView;

      var showActualView = void 0;

      switch (currentView) {
        case 1:
          showActualView = _react2.default.createElement(
            'div',
            { key: "aboutElement" + currentView, className: "aboutElement " + elem1.name.toLowerCase() },
            _react2.default.createElement(_About.CustomAbout, { strings: investigations })
          );
          break;

        case 2:
          showActualView = _react2.default.createElement(
            'div',
            { key: "aboutElement" + currentView, className: "aboutElement " + elem2.name.toLowerCase() },
            _react2.default.createElement(_About.Dictionary, { strings: dictionary })
          );
          break;

        case 3:
          showActualView = _react2.default.createElement(
            'div',
            { key: "aboutElement" + currentView, className: "aboutElement " + elem3.name.toLowerCase() },
            _react2.default.createElement(_About.CustomAbout, { strings: tutorials })
          );
          break;

      }

      var headerStyle = this.state.headerStyle;

      return _react2.default.createElement(
        _reactAddonsCssTransitionGroup2.default,
        { transitionName: 'view', transitionAppear: true, transitionAppearTimeout: 1500, transitionEnter: true, transitionEnterTimeout: 1500, transitionLeave: true, transitionLeaveTimeout: 1500 },
        _react2.default.createElement(
          _reactBodyClassname2.default,
          { className: 'about' },
          _react2.default.createElement(
            _Util.ScrollWrapper,
            { onWindowScroll: this.handleScroll },
            _react2.default.createElement(
              'div',
              { className: 'about' },
              _react2.default.createElement(
                'video',
                { className: 'bgVideo', width: '100%', height: '100%', autoPlay: true, loop: true, muted: true },
                _react2.default.createElement('source', { src: this.context.baseUrl + "/media/video/bgHomeLow.mp4", type: 'video/mp4' })
              ),
              _react2.default.createElement(
                'div',
                { className: "aboutHeader " + headerStyle },
                _react2.default.createElement(
                  'h1',
                  null,
                  title
                ),
                _react2.default.createElement(
                  'nav',
                  null,
                  _react2.default.createElement(
                    'ul',
                    null,
                    (0, _keys2.default)(menu).map(function (key, index) {
                      return _react2.default.createElement(
                        'li',
                        { key: key, onClick: this.changeView.bind(this), 'data-position': parseInt(index + 1), className: 'linkToPart' },
                        _react2.default.createElement(
                          'span',
                          { className: 'text' },
                          menu[key].name
                        ),
                        _react2.default.createElement('span', { className: index == 0 ? "bottomLine active" : "bottomLine" })
                      );
                    }, this)
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'container' },
                _react2.default.createElement(
                  _reactAddonsCssTransitionGroup2.default,
                  { transitionName: 'view', transitionAppear: true, transitionAppearTimeout: 1500, transitionEnter: true, transitionEnterTimeout: 1500, transitionLeave: true, transitionLeaveTimeout: 1500 },
                  showActualView
                )
              )
            )
          )
        )
      );
    }
  }]);
  return About;
}(_react.Component), _class2.contextTypes = {
  baseUrl: _react.PropTypes.string.isRequired,
  project: _react.PropTypes.string.isRequired,
  router: _react2.default.PropTypes.object.isRequired
}, _temp)) || _class);
;

exports.default = (0, _translate2.default)('About')(About);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/About/About.js
// module id = 810
// module chunks = 0